'use strict';

/**
 * Default setting index view
 *
 * @category   View
 * @module     dashboard
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/helpdesk/templates/layout/contact.hbs');

var ContactLayout = LayoutView.extend({
    template: template,

    ui: {
        'autosizeTextarea': 'textarea[data-autosize="true"]',
    },

    events: {
        'input @ui.autosizeTextarea': 'fixTextareaSize',
    },

    onAttach: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },
});

module.exports = ContactLayout;